import React from "react"
import { MenuItem, TextField, Box, TextFieldProps } from "@mui/material"
import { styled } from "@mui/material/styles"
import { ToggleButtonGroup, ToggleButton } from "@mui/material"

import SystemConfigurationDialog from "components/Dialogs/SystemConfigurationDialog"
import MeasureCylinderDialog from "components/Dialogs/MeasureCylinderDialog"

import useLengthCombinationsBySystemConfiguration from "@secureo/common/hooks/cylinderConfigurations/useLengthCombinationsBySystemConfiguration"

import { LengthCombinationsBySystem } from "@secureo/common/typings/Product"

export const StyledToggleButtonGroup = styled(ToggleButtonGroup)(() => ({
	"& .MuiToggleButtonGroup-grouped": {
		marginRight: 10,
		border: "1px solid #B8BCBF",
		whiteSpace: "nowrap",
		textTransform: "inherit",
		padding: 7,
		paddingLeft: 10,
		paddingRight: 10,
		color: "#505E5F",
		"&:not(:first-child)": {
			border: "1px solid #B8BCBF",
			borderRadius: 3,
		},
		"&:first-child": {
			borderRadius: 3,
		},
	},
}))

const SystemAndLengthCombinationConfigurationInput = ({
	lengthCombinationsBySystem,
	selectedSystem,
	selectedOuterLength,
	selectedInnerLength,
	onSystemChange,
	onOuterLengthChange,
	onInnerLengthChange,
	disabled,
	showMeasureCylinderDialog,
	systemConfigurationToolTip,
	margin = "normal",
}: Props) => {
	const {
		systemInputProps,
		outerLengthInputProps,
		innerLengthInputProps,
		availableOuterLengths,
		availableInnerLengths,
		availableSystems,
	} = useLengthCombinationsBySystemConfiguration(
		lengthCombinationsBySystem,
		selectedSystem,
		selectedOuterLength,
		selectedInnerLength,
		onSystemChange,
		onOuterLengthChange,
		onInnerLengthChange,
	)

	return (
		<>
			<Box mt={1} mb={1} style={{ display: "flex", alignItems: "center" }}>
				<SystemConfigurationDialog
					systemConfigurationToolTip={systemConfigurationToolTip}
				/>
			</Box>

			{/* TODO: Make awesome slider*/}
			<StyledToggleButtonGroup
				{...systemInputProps}
				exclusive
				aria-label="text alignment"
				style={{ display: "flex", flexWrap: "wrap" }}
			>
				{availableSystems.map((system) => (
					<ToggleButton
						key={system}
						value={system}
						disabled={disabled}
						style={{ marginBottom: 8 }}
					>
						<strong>{system}</strong>
					</ToggleButton>
				))}
			</StyledToggleButtonGroup>
			{showMeasureCylinderDialog && (
				<Box mt={1} mb={-1} style={{ display: "flex", alignItems: "center" }}>
					<MeasureCylinderDialog />
				</Box>
			)}
			<div style={{ display: "flex", alignItems: "center" }}>
				<div style={{ width: "50%" }}>
					<TextField
						id="outerLength"
						label="Außenlänge"
						{...outerLengthInputProps}
						margin={margin}
						variant="filled"
						select
						fullWidth
						disabled={disabled}
					>
						{availableOuterLengths.map((outerLength) => (
							<MenuItem key={outerLength} value={outerLength}>
								{outerLength} mm
							</MenuItem>
						))}
					</TextField>
				</div>
				<Box ml={1} style={{ width: "50%" }}>
					<TextField
						id="innerLength"
						label="Innenlänge"
						{...innerLengthInputProps}
						margin={margin}
						variant="filled"
						select
						fullWidth
						disabled={disabled}
					>
						{availableInnerLengths.map((innerLength) => (
							<MenuItem key={innerLength} value={innerLength}>
								{innerLength} mm
							</MenuItem>
						))}
					</TextField>
				</Box>
			</div>
		</>
	)
}

interface Props {
	lengthCombinationsBySystem: LengthCombinationsBySystem
	selectedSystem: string
	selectedOuterLength: number
	selectedInnerLength: number
	onSystemChange: (selectedSystem: string) => void
	onOuterLengthChange: (selectedOuterLength: number) => void
	onInnerLengthChange: (selectedInnerLength: number) => void
	systemConfigurationToolTip?: string
	disabled?: boolean
	showMeasureCylinderDialog?: boolean
	margin?: TextFieldProps["margin"]
}

export default SystemAndLengthCombinationConfigurationInput
